import * as _ from 'lodash';
import { DeliveryDateRange } from 'app/b2b-order/types/preorder';

const deliveryDateStructure = /^(\d{4})(\d{2})(\d{2})$/;

export const isDeliveryDateRange = (value: string | DeliveryDateRange): value is DeliveryDateRange =>
    _.has(value, 'deliveryDateFrom') && _.has(value, 'deliveryDateTo');

export function formatDeliveryDateToText(deliveryDate: string | DeliveryDateRange) {
    if (isDeliveryDateRange(deliveryDate)) {
        const datesMatch = [
            deliveryDate.deliveryDateFrom.match(deliveryDateStructure),
            deliveryDate.deliveryDateTo.match(deliveryDateStructure)
        ];
        return datesMatch.every((dateMatch) => !!dateMatch)
            ? datesMatch.map((dateMatch) => dateMatch.slice(1, 4).reverse().join('.')).join(' - ')
            : deliveryDate.deliveryDateFrom + ' - ' + deliveryDate.deliveryDateTo;
    }

    return deliveryDateStructure.test(deliveryDate)
        ? deliveryDate.match(deliveryDateStructure).slice(1, 4).reverse().join('.')
        : deliveryDate;
}

export function formatDeliveryDateToItem(deliveryDate: string | DeliveryDateRange) {
    return {
        text: formatDeliveryDateToText(deliveryDate),
        label: formatDeliveryDateToText(deliveryDate),
        value: deliveryDate
    };
}
